var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonTwin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1163_19648",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 60,
    height: 61
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5H66V66.5H6V6.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1163_19648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7812 32.2812C31.7812 34.87 29.6825 36.9688 27.0938 36.9688H13.0312C10.4425 36.9688 8.34375 34.87 8.34375 32.2812V13.5312C8.34375 10.9425 10.4425 8.84375 13.0312 8.84375H27.0938C29.6825 8.84375 31.7812 10.9425 31.7812 13.5312V32.2812Z",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6562 59.4687C63.6562 62.0575 61.5575 64.1562 58.9688 64.1562H44.9062C42.3175 64.1562 40.2188 62.0575 40.2188 59.4687V40.7187C40.2188 38.13 42.3175 36.0312 44.9062 36.0312H58.9688C61.5575 36.0312 63.6562 38.13 63.6562 40.7187V59.4687Z",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7812 59.4688C31.7812 62.0575 29.6825 64.1562 27.0938 64.1562H13.0312C10.4425 64.1562 8.34375 62.0575 8.34375 59.4688V50.0938C8.34375 47.505 10.4425 45.4062 13.0312 45.4062H27.0938C29.6825 45.4062 31.7812 47.505 31.7812 50.0938V59.4688Z",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6562 22.9062C63.6562 25.495 61.5575 27.5938 58.9688 27.5938H44.9062C42.3175 27.5938 40.2188 25.495 40.2188 22.9062V13.5312C40.2188 10.9425 42.3175 8.84375 44.9062 8.84375H58.9688C61.5575 8.84375 63.6562 10.9425 63.6562 13.5312V22.9062Z",
    stroke: "#667085",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonTwin);
export default __webpack_public_path__ + "static/media/personTwin.95f1d27c47f20e41f9094ebf056a69c3.svg";
export { ForwardRef as ReactComponent };